import React, { useContext } from "react";
import { Avatar } from "antd";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import ServiceApi from "../services/ServiceApi";
import { authUserContext } from "../contexts/authContext";
import Action from "../actions/NotificationHistoryAction";

const NotificationBoldGroup = () => {
  const auth = useContext(authUserContext);
  const dispatch = useDispatch();
  const { notificationList } = useSelector((state) => ({
    notificationList: state.notificationHistory.notifications,
  }));

  const handleClick = (item) => {
    ServiceApi.post("notification/readhistory", {
      notificationId: item.notificationId,
      companyId: item.companyId,
      operatorId: item.operatorId,
      projectId: item.projectId,
      jobId: item.jobId,
      userId: auth.userId,
    })
      .then(({ data: res }) => {
        if (res.result.code === "P") {
          dispatch({
            type: Action.SET_NOTIFICATION_HISTORY_LIST,
            payloads: notificationList.map((s) => {
              if (s.notificationId === item.notificationId) {
                return { ...s, isRead: 1 };
              }
              return s;
            }),
          });
        }
      })
      .catch();
    window.open(
      ServiceApi.absoluteUrl(
        `/full_detail_job/${item.companyId}/${item.operatorId}/${item.projectId}/${item.jobId}`
      )
    );
  };

  return (
    <>
      <div className="wrapper-noti position-fixed">
        <div className="ant-collapse-item ant-collapse-item-active mt-1">
          <div
            style={{
              alignItems: "flex-end",
              padding: "8px 0px",
              borderBottom: "1px solid #e8ecef",
              margin: "0 14px",
            }}
          >
            <img
              src={ServiceApi.absoluteUrl("/icon/notifications.svg")}
              width="30"
              alt=""
            />
            <b className="ml-1 c-blue">NOTIFICATIONS</b>
          </div>
          {notificationList.length ? (
            <ul>
              {notificationList.map((item, index) => (
                <li
                  style={{
                    height: "auto",
                    borderBottom: "1px solid #e8ecef",
                    margin: "0 8px",
                    padding: "14px 12px",
                    backgroundColor: !item.isRead ? "#e7f3ff" : "#fff",
                  }}
                  className="d-flex justify-content-between"
                  key={index}
                  onClick={() => handleClick(item)}
                >
                  <div
                    className="row"
                    style={{ alignItems: "center", width: "100%" }}
                  >
                    <div>
                      <Avatar
                        style={{
                          backgroundColor: "#fde3cf",
                          verticalAlign: "middle",
                          color: "#f56a00",
                        }}
                        size="large"
                        gap="#fde3cf"
                      >
                        {item.sendFromEmpName?.charAt(0).toUpperCase()}
                      </Avatar>
                    </div>
                    <div className="col" style={{ paddingLeft: 15 }}>
                      <div className="row">
                        <div className="col-6" style={{ padding: 5 }}>
                          <h5 className="font-thai-b fs-18 m-0">
                            {item.title}
                          </h5>
                        </div>
                        <div
                          className="col-6"
                          style={{ padding: 5, textAlign: "end" }}
                        >
                          <span
                            className="font-thai-r fs-18"
                            style={{ color: "rgba(0,0,0,.5)" }}
                          >
                            {moment(item.createDate).format(
                              "HH:mm | DD MMM YY"
                            )}
                          </span>
                        </div>
                      </div>

                      <p className="font-thai-r fs-18" style={{ margin: 0 }}>
                        {item.message}
                      </p>
                      <p className="font-thai-r fs-18" style={{ margin: 0 }}>
                        {`Job No : ${item.jobNo}`}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div style={{ textAlign: "center", padding: "30px 0" }}>
              <span style={{ color: "red" }}>"ไม่มีการแจ้งเตือน"</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationBoldGroup;
